import { render, staticRenderFns } from "./AttachmentEdit.vue?vue&type=template&id=997d6f0e&scoped=true"
import script from "./AttachmentEdit.vue?vue&type=script&lang=js"
export * from "./AttachmentEdit.vue?vue&type=script&lang=js"
import style0 from "./AttachmentEdit.vue?vue&type=style&index=0&id=997d6f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d6f0e",
  null
  
)

export default component.exports